import { QueryStatus } from "@hex-insights/app-modules";
import { Button, Column, Conditional, Else, If, Row } from "@hex-insights/core";
import { Table } from "@hex-insights/tables";
import { CourseSectionAttendanceRecordsReportQuery } from "../../../../../../../../Utilities";
import { StudentFormat } from "../../../../../../../Format";
import * as AttendanceStatusComponents from "../../../../../../AttendanceStatus";
import styles from "../general.module.css";

const tableColumns = ["student", "attendanceStatus", "notes", "attendanceRecord"];

export type CourseAttendanceRecordsTableProps = {
	data: CourseSectionAttendanceRecordsReportQuery | undefined;
	queryStatus: QueryStatus;
};

export function CourseAttendanceRecordsTable({ data, queryStatus }: CourseAttendanceRecordsTableProps) {
	return (
		<Table columns={tableColumns} className={styles["table"]}>
			<Table.Header>
				<Table.Row>
					<Table.Heading column="student" noResize className={styles["table__heading"]}>
						Student
					</Table.Heading>
					<Table.Heading column="attendanceStatus" noResize className={styles["table__heading"]}>
						Attendance Status
					</Table.Heading>
					<Table.Heading column="notes" noResize className={styles["table__heading"]}>
						Notes
					</Table.Heading>
					<Table.Heading
						column="attendanceRecord"
						noResize
						className={styles["table__heading"]}
						style={{ textAlign: "right" }}
					>
						Attendance Record
					</Table.Heading>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				<Conditional>
					<If condition={queryStatus === "results"}>
						{data?.studentConnection.edges.map(({ node }) => (
							<Table.Row key={node.id}>
								<Table.Cell column="student" oneLine className={styles["table__cell"]}>
									{StudentFormat.name(node)}
								</Table.Cell>
								<Table.Cell column="attendanceStatus" oneLine className={styles["table__cell"]} style={{ padding: 0 }}>
									<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem" style={{ height: "100%" }}>
										<Conditional>
											<If condition={node.courseAttendanceRecords?.length !== 0}>
												{node.courseAttendanceRecords.map((record) => (
													<AttendanceStatusComponents.AttendanceStatusBadge
														key={record.id}
														attendanceStatus={record.attendanceStatus}
														className={styles["table__badge"]}
													/>
												))}
											</If>
											<Else>
												<AttendanceStatusComponents.AttendanceStatusBadge
													attendanceStatus={null}
													className={styles["table__badge"]}
												/>
											</Else>
										</Conditional>
									</Row>
								</Table.Cell>
								<Table.Cell column="notes" oneLine className={styles["table__cell"]}>
									{node.courseAttendanceRecords.map((record) => record.notes).join("\n\n")}
								</Table.Cell>
								<Table.Cell column="attendanceRecord" oneLine className={styles["table__cell"]} style={{ padding: 0 }}>
									<Column justify="center" align="flex-end" style={{ height: "100%" }}>
										<Button variant="link" size="small" onClick={() => {}}>
											View
										</Button>
									</Column>
								</Table.Cell>
							</Table.Row>
						))}
					</If>
					<Else>
						<Table.Row>
							<Table.Cell column={tableColumns[0]} colspan={tableColumns.length} className={styles["table__cell"]}>
								<Conditional>
									<If condition={queryStatus === "no-results"}>No results found.</If>
									<If condition={queryStatus === "error"}>Something went wrong</If>
									<If condition={queryStatus === "loading"}>Loading...</If>
								</Conditional>
							</Table.Cell>
						</Table.Row>
					</Else>
				</Conditional>
			</Table.Body>
		</Table>
	);
}
